import {
  Alert,
  Card,
  Col,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Tag,
} from "antd";
import {
  daysJsFormat,
  formatCurrency,
  languagesList,
  renderDiplomas,
  renderInterpreteCountry,
  renderLevel,
  renderUserGenderShort,
  renderUserName,
  roles,
  statusOption,
  statusPrestationsValues,
  typeIntervention,
} from "../../../utils/constants";
import {
  changePositionInterprete,
  changeStatusInterprete,
  setPrestation,
  setSelectedInterprete,
  updatePrestation,
} from "../Slices/Prestation.slice";
import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import {
  confirmDirecteInterpreteInvitation,
  confirmRelanceInterpreteInvitation,
  errorIcon,
  manuelAttributeInterprete,
  validIcon,
} from "../../../shared/components/Modals/modals";
import dayjs from "../../../utils/dayjs";
import dateFormat from "dateformat";
import { UserContext } from "../../../engine/context/User.context";
import { http } from "../../../engine/api/http";
import dayjsNormal from "dayjs";
import { onlyRoleMapping } from "../../../engine/AuthRoute";

export const prestationInterpretesColumns = (prestation, isAdmin) => {
  const dispatch = useDispatch();

  const { user } = useContext(UserContext);

  const byStatus = value => {
    if (
      prestation.status === statusPrestationsValues.draft &&
      value === "relance"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const byStatusInstitution = value => {
    if (user.role === roles.institution) {
      if (
        value === "selected" ||
        value === "not_available" ||
        value === "relance"
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "position",
      rowScope: "row",
      key: "position",
      width: "30px",
      render: (position, record) => (
        <>
          <Tag className={"largeTag"} size={"large"} color={"red"}>
            {record.position}
          </Tag>
        </>
      ),
    },
    {
      title: "Interprète",
      width: "120px",
      dataIndex: "user",
      key: "user",
      render: (text, record) => (
        <strong>{renderUserName(record.interprete)}</strong>
      ),
    },
    {
      title: "Genre",
      dataIndex: "genre",
      key: "genre",
      width: "40px",
      render: (g, record) => renderUserGenderShort(record.interprete),
    },

    {
      title: "Niveau",
      dataIndex: "levels",
      key: "levels",
      width: "100px",
      render: (text, record) => <span>{renderLevel(record?.interprete)} </span>,
    },
    {
      title: "Langue(s) interprétée(s)",
      dataIndex: "interpreteData",
      key: "interpreteData",
      width: "150px",
      render: (interpreteData, record) =>
        record.interprete.interpreteData.languages.map(lang => (
          <Tag size={"middle"} className={"greyTag"}>
            {languagesList.find(e => e.value === lang)?.label}
          </Tag>
        )),
    },
    {
      title: "Frais de déplacement (H.T)",
      dataIndex: "cost",
      key: "cost",
      width: "100px",
      render: (cost, record) => {
        return (
          <span>
            {typeIntervention.in_person === prestation.intervention.type
              ? formatCurrency(cost)
              : 0}
          </span>
        );
      },
    },
    {
      title: "Action & Ordre",
      dataIndex: "action",
      key: "action",
      width: "150px",
      render: (text, record) => {
        const deepCopy = JSON.parse(JSON.stringify(record.emailsSent));
        let last = null;
        if (deepCopy !== null) {
          const emails = deepCopy.sort((a, b) => {
            return new Date(b.send_at) - new Date(a.send_at);
          });

          last = emails ? emails[0] : null;
        }

        let disabledSelect = false;

        if (user.role === roles.institution) {
          disabledSelect = record.status === "not_available";
        }

        return (
          <Space direction={"vertical"}>
            <Select
              disabled={
                (prestation.status !== statusPrestationsValues.draft &&
                  prestation.status !== statusPrestationsValues.waiting) ||
                disabledSelect
              }
              key={record._id + record.status}
              value={record.status}
              style={{ width: 160 }}
              onChange={newValue => {
                if (newValue === "selected") {
                  manuelAttributeInterprete({
                    onOk: async () => {
                      await dispatch(
                        setSelectedInterprete(record.interprete._id),
                      );
                      await dispatch(
                        changeStatusInterprete({
                          _id: record.interprete._id,
                          status: newValue,
                        }),
                      );
                    },
                    content: {
                      record,
                    },
                  });
                } else if (newValue === "relance") {
                  confirmRelanceInterpreteInvitation({
                    content: {
                      user: record.interprete,
                    },
                    onOk: async () => {
                      // dispatch(
                      //   changeStatusInterprete({
                      //     _id: record.interprete._id,
                      //     status: newValue,
                      //   }),
                      // );
                      try {
                        const sendDirectEmail = await http.post(
                          `/prestations/${prestation._id}/relance/${record.interprete._id}`,
                        );

                        await dispatch(setPrestation(sendDirectEmail.data));
                        notification.success({
                          message:
                            "L'email de relance a été envoyé avec succès.",
                        });
                      } catch (e) {
                        notification.error({
                          message:
                            "Une erreur est survenue lors de l'envoi de l'email de relance",
                        });
                      }
                    },
                  }).then(() => {});
                } else if (
                  newValue === "invited" &&
                  prestation.status !== statusPrestationsValues.draft
                ) {
                  confirmDirecteInterpreteInvitation({
                    content: {
                      user: record.interprete,
                    },
                    onOk: async () => {
                      // dispatch(
                      //   changeStatusInterprete({
                      //     _id: record.interprete._id,
                      //     status: newValue,
                      //   }),
                      // );
                      try {
                        const sendDirectEmail = await http.post(
                          `/prestations/${prestation._id}/relance/${record.interprete._id}`,
                        );

                        await dispatch(setPrestation(sendDirectEmail.data));
                        notification.success({
                          message:
                            "L'email de relance a été envoyé avec succès.",
                        });
                      } catch (e) {
                        notification.error({
                          message:
                            "Une erreur est survenue lors de l'envoi de l'email de relance",
                        });
                      }
                    },
                  }).then(() => {});
                } else {
                  dispatch(
                    changeStatusInterprete({
                      _id: record.interprete._id,
                      status: newValue,
                    }),
                  );
                }
              }}
              popupClassName={"colorfull"}
              className={"colorfull"}
            >
              {statusOption
                .filter(p => {
                  // Filter pour cacher certain cas. 2ème fois demandé par le client en date du 7 janvier 2025
                  // OSEO-469 Jira

                  // if (isAdmin) {
                  //   return true;
                  // } else {
                  //   let forbidden = ["relance", "selected"];
                  //   return !forbidden.includes(p.value);
                  // }

                  return true;
                })
                .map(option => {
                  return (
                    <Select.Option
                      key={option?.value}
                      value={option?.value}
                      disabled={
                        option?.disabled ||
                        false ||
                        byStatus(option?.value) ||
                        byStatusInstitution(option?.value)
                      }
                    >
                      {option?.label()}
                    </Select.Option>
                  );
                })}
            </Select>
            {last !== undefined && last !== null ? (
              <cite>
                Dernier email envoyé le{" "}
                {dayjs(last.send_at).format(daysJsFormat.full)}
              </cite>
            ) : (
              ""
            )}
            {/*<Select*/}
            {/*  key={record._id + record.position}*/}
            {/*  value={record.position}*/}
            {/*  style={{ width: 100 }}*/}
            {/*  onChange={newValue => {*/}
            {/*    dispatch(*/}
            {/*      changePositionInterprete({*/}
            {/*        _id: record.interprete._id,*/}
            {/*        position: newValue,*/}
            {/*      }),*/}
            {/*    );*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <Select.Option key={1} value={1}>*/}
            {/*    Batch 1*/}
            {/*  </Select.Option>*/}
            {/*  <Select.Option key={2} value={2}>*/}
            {/*    Batch 2*/}
            {/*  </Select.Option>*/}
            {/*  <Select.Option key={3} value={3}>*/}
            {/*    Batch 3*/}
            {/*  </Select.Option>*/}
            {/*  <Select.Option key={4} value={4}>*/}
            {/*    Batch 4*/}
            {/*  </Select.Option>*/}
            {/*</Select>*/}
            {/*<label>*/}
            {/*  {notActive ? "Refusé" : "Invité"}*/}
            {/*  <Switch*/}
            {/*    checked={!notActive}*/}
            {/*    onClick={() => {*/}
            {/*      if (notActive) {*/}
            {/*        setNotInvited([...notInvited, record._id]);*/}
            {/*      } else {*/}
            {/*        setNotInvited([*/}
            {/*          ...notInvited.filter(e => e !== record._id),*/}
            {/*        ]);*/}
            {/*      }*/}
            {/*    }}*/}
            {/*  />*/}
            {/*</label>*/}
            {/*<Button*/}
            {/*  className={`${notActive ? "notActiveButton " : "activeButton"}`}*/}
            {/*  size={"middle"}*/}
            {/*  type={"primary"}*/}
            {/*  onClick={() => {*/}
            {/*    if (!notActive) {*/}
            {/*      setNotInvited([...notInvited, record._id]);*/}
            {/*    } else {*/}
            {/*      setNotInvited([...notInvited.filter(e => e !== record._id)]);*/}
            {/*    }*/}
            {/*  }}*/}
            {/*>*/}
            {/*  {notActive ? "Refusé" : "Invité"}*/}
            {/*  {notActive ? <BiPlus /> : <BiCheck />}*/}
            {/*</Button>*/}
          </Space>
        );
      },
    },
  ];
  return columns;
};

export const expandedRowRenderDetailInterpretes = props => {
  const {
    interprete,
    driving,
    conflictingHolidays,
    invalidTimeSlots,
    isValidSchedule,
    prestationsSameTime,
  } = props;
  const { formations, country, lastDateFormation } = interprete.interpreteData;

  return (
    <div>
      <Row gutter={[15, 15]}>
        {onlyRoleMapping([roles.admin, roles.permanance]) && (
          <Col span={24}>
            <Card title={"Disponibilités"}>
              <Row gutter={[5, 5]}>
                <Col span={8}>
                  <span className={"subTableOpenedInterprtesTitle"}>
                    Disponibilités hebdomadaires
                  </span>
                  <span className={"subTableOpenedInterprtesContent"}>
                    {invalidTimeSlots !== undefined ? (
                      <Alert
                        size={"small"}
                        icon={isValidSchedule ? validIcon : errorIcon}
                        message={
                          invalidTimeSlots.length > 0 ? (
                            <span>
                              {invalidTimeSlots.map(time => {
                                return (
                                  <span>
                                    Disponible uniquement de{" "}
                                    {dayjsNormal(
                                      `${time.from.hour}:${time.from.minute}`,
                                      daysJsFormat.hour,
                                    ).format(daysJsFormat.hour)}{" "}
                                    à{" "}
                                    {dayjsNormal(
                                      `${time.to.hour}:${time.to.minute}`,
                                      daysJsFormat.hour,
                                    ).format(daysJsFormat.hour)}
                                    <br />
                                  </span>
                                );
                              })}
                            </span>
                          ) : (
                            <>
                              {isValidSchedule
                                ? "Disponible"
                                : "Indisponible toute la journée"}
                            </>
                          )
                        }
                        type={isValidSchedule ? "success" : "error"}
                        showIcon
                      />
                    ) : (
                      "Donnée non disponible, merci d'effectuer une nouvelle recherche."
                    )}
                  </span>
                </Col>
                <Col span={8}>
                  <span className={"subTableOpenedInterprtesTitle"}>
                    Vacances
                  </span>
                  <span className={"subTableOpenedInterprtesContent"}>
                    {conflictingHolidays !== undefined ? (
                      <Alert
                        size={"small"}
                        icon={
                          conflictingHolidays.length > 0 ? errorIcon : validIcon
                        }
                        message={
                          conflictingHolidays.length > 0 > 0 ? (
                            <span>
                              {conflictingHolidays.map(holiday => {
                                return (
                                  <>
                                    Vacances du{" "}
                                    {dayjs(holiday.dateFrom).format(
                                      daysJsFormat.day,
                                    )}{" "}
                                    au{" "}
                                    {dayjs(holiday.dateTo).format(
                                      daysJsFormat.day,
                                    )}
                                  </>
                                );
                              })}
                            </span>
                          ) : (
                            <>Aucune vacances</>
                          )
                        }
                        type={
                          conflictingHolidays.length > 0 ? "error" : "success"
                        }
                        showIcon
                      />
                    ) : (
                      "Donnée non disponible, merci d'effectuer une nouvelle recherche."
                    )}
                  </span>
                </Col>
                <Col span={8}>
                  <span className={"subTableOpenedInterprtesTitle"}>
                    Prestations
                  </span>
                  <span className={"subTableOpenedInterprtesContent"}>
                    {prestationsSameTime !== undefined ? (
                      <Alert
                        size={"small"}
                        icon={
                          prestationsSameTime.length > 0 ? errorIcon : validIcon
                        }
                        message={
                          prestationsSameTime.length > 0 > 0 ? (
                            <span>
                              {prestationsSameTime.map(pre => {
                                return (
                                  <>
                                    La prestation {pre.reference} est en même
                                    temps. Le{" "}
                                    {dayjs(pre.finalStartDate).format(
                                      daysJsFormat.full,
                                    )}{" "}
                                    à{" "}
                                    {dayjs(pre.finalEndDate).format(
                                      daysJsFormat.full,
                                    )}
                                  </>
                                );
                              })}
                            </span>
                          ) : (
                            <>Aucune prestation.</>
                          )
                        }
                        type={
                          prestationsSameTime.length > 0 ? "error" : "success"
                        }
                        showIcon
                      />
                    ) : (
                      "Donnée non disponible, merci d'effectuer une nouvelle recherche."
                    )}
                  </span>
                </Col>
                {/*<Col span={6}>*/}
                {/*  <span className={"subTableOpenedInterprtesTitle"}>*/}
                {/*    Pays d'origine*/}
                {/*  </span>*/}
                {/*  <span className={"subTableOpenedInterprtesContent"}>*/}
                {/*    {renderInterpreteCountry(interprete)}*/}
                {/*  </span>*/}
                {/*</Col>*/}
              </Row>
            </Card>
          </Col>
        )}

        <Col span={24}>
          <Card title={"Qualifications"}>
            <Row gutter={[5, 5]}>
              <Col span={8}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  Cours suivis
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {formations}
                </span>
              </Col>
              <Col span={8}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  Dernière date de suivi
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {lastDateFormation !== null || lastDateFormation !== ""
                    ? dayjs(lastDateFormation).format(daysJsFormat.full)
                    : ""}
                </span>
              </Col>
              <Col span={8}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  Qualifications
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {renderDiplomas(interprete)}
                </span>
              </Col>
              {/*<Col span={6}>*/}
              {/*  <span className={"subTableOpenedInterprtesTitle"}>*/}
              {/*    Pays d'origine*/}
              {/*  </span>*/}
              {/*  <span className={"subTableOpenedInterprtesContent"}>*/}
              {/*    {renderInterpreteCountry(interprete)}*/}
              {/*  </span>*/}
              {/*</Col>*/}
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
